var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _g2, _path0, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _g4, _path16, _path17, _path18, _path19, _g5, _path20, _path21, _path22, _path23, _g6, _path24, _path25, _path26, _path27, _g7, _path28, _path29, _path30, _path31, _g8, _path32, _path33, _path34, _path35, _g9, _path36, _path37, _path38, _path39, _g0, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10Users(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 189,
    viewBox: "0 0 214 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.889 78.0463C192.092 46.6457 172.423 8.06775 133.565 4.03054C133.565 4.03054 104.062 0.441974 74.9785 5.8808C57.7175 9.10877 42.5821 18.7177 33.005 32.5281C23.4278 46.3385 20.2288 63.1785 24.1112 79.2334C26.6328 89.6611 28.3369 100.453 27.8692 111.169C27.0553 129.817 27.5236 147.224 45.6217 158.346C61.7812 168.276 82.1182 177.034 101.52 178.568C114.705 179.611 129.492 177.924 142.2 174.491C206.964 156.996 201.687 109.447 196.889 78.0463Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.711 118.574C130.357 119.388 120.938 110.7 120.938 99.1911C120.938 87.6823 130.357 78.0094 141.711 77.6361C152.826 77.2706 161.698 85.9873 161.698 97.06C161.698 108.133 152.826 117.777 141.711 118.574Z",
    fill: "url(#paint0_linear_297_59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.096 119.035C131.741 119.849 122.322 111.161 122.322 99.652C122.322 88.1431 131.741 78.4703 143.096 78.097C154.211 77.7315 163.082 86.4483 163.082 97.5209C163.082 108.594 154.211 118.238 143.096 119.035Z",
    fill: "url(#paint1_linear_297_59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.728 97.5923C161.728 107.931 153.468 116.894 143.096 117.624C132.515 118.368 123.781 110.294 123.781 99.5764C123.781 88.8587 132.515 79.8713 143.096 79.5093C153.468 79.1543 161.728 87.2532 161.728 97.5923Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 80,
    width: 36,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.37 97.6638C160.37 107.25 152.706 115.549 143.095 116.213C133.306 116.888 125.235 109.411 125.235 99.5007C125.235 89.5904 133.306 81.2695 143.095 80.9214C152.706 80.5797 160.37 88.078 160.37 97.6638Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.815 85.4737C137.456 85.5905 134.268 87.6653 132.853 90.3516C131.149 93.5882 133.425 95.001 132.313 100.151C131.289 104.895 128.899 105.848 129.294 108.892C129.726 112.228 132.993 114.153 134.284 114.914C140.091 118.337 149.167 117.606 153.777 112.416C154.162 111.982 157.344 108.4 156.485 105.345C155.717 102.612 152.421 102.804 151.739 99.9572C151.151 97.5048 153.402 96.5546 153.188 92.9585C153.146 92.2549 152.948 88.9246 150.442 87.5435C148.774 86.6239 146.941 87.0388 146.269 87.2268C145.463 86.6351 143.499 85.3804 140.815 85.4737Z",
    fill: "url(#paint2_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.781 112.673C123.781 112.673 140.75 101.675 161.728 110.226C161.728 110.226 159.056 118.879 143.096 120.462C126.637 122.094 123.781 112.673 123.781 112.673Z",
    fill: "url(#paint3_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.089 98.7236L139.453 103.499C139.236 105.129 138.123 106.551 136.576 107.173L131.403 109.252C131.403 109.252 141.303 113.392 153.806 107.823L148.106 106.198C146.488 105.692 145.385 104.229 145.315 102.491L145.151 98.459L140.089 98.7236Z",
    fill: "url(#paint4_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.803 94.142C147.803 98.1392 145.398 102.569 142.415 102.736C139.415 102.905 136.971 98.7037 136.971 94.6653C136.971 90.6269 139.415 88.3143 142.415 88.1871C145.398 88.0605 147.803 90.1448 147.803 94.142Z",
    fill: "url(#paint5_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.801 90.6712C143.181 90.8282 140.727 91.3304 139.027 93.1976C136.174 96.3326 137.529 101.005 136.259 101.355C135.128 101.667 133.377 98.3824 133.405 94.6728C133.429 91.566 134.491 87.8584 137.255 86.8224C138.878 86.2139 139.356 87.0725 144.591 87.3679C147.641 87.5401 146.444 88.9616 147.13 89.4416C150.176 91.5728 149.791 99.0489 148.151 99.2311C147.374 99.3176 146.3 97.4257 144.801 90.6712Z",
    fill: "url(#paint6_linear_297_59)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.752 78.5939C167.135 78.964 157.5 69.5322 157.5 57.5619C157.5 45.5914 167.135 35.9198 178.752 36.0005C190.129 36.0796 199.213 45.5183 199.213 57.0425C199.213 68.5666 190.129 78.2315 178.752 78.5939Z",
    fill: "url(#paint7_linear_297_59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.216 78.5939C168.599 78.964 158.964 69.5322 158.964 57.5619C158.964 45.5914 168.599 35.9198 180.216 36.0005C191.593 36.0796 200.676 45.5183 200.676 57.0425C200.676 68.5666 191.593 78.2315 180.216 78.5939Z",
    fill: "url(#paint8_linear_297_59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.29 57.0596C199.29 67.8199 190.833 76.801 180.216 77.125C169.39 77.4554 160.456 68.6909 160.456 57.5431C160.456 46.3953 169.39 37.4083 180.216 37.4691C190.833 37.5286 199.29 46.2991 199.29 57.0596Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 38,
    width: 37,
    height: 38
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.9 57.0767C197.9 67.0529 190.054 75.3691 180.217 75.6561C170.2 75.9484 161.944 67.8327 161.944 57.5244C161.944 47.2161 170.2 38.8948 180.217 38.9377C190.054 38.9797 197.9 47.1005 197.9 57.0767Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.456 71.2136C160.456 71.2136 177.816 60.4814 199.29 70.255C199.29 70.255 196.554 79.1485 180.216 80.1258C163.378 81.133 160.456 71.2136 160.456 71.2136Z",
    fill: "url(#paint9_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.139 57.334L176.488 62.276C176.299 65.4177 173.25 66.6605 173.25 66.6605C176.83 70.9074 183.674 70.5846 186.067 66.4316C184.414 65.8389 182.559 63.2827 182.487 61.4717L182.32 57.2695L177.139 57.334Z",
    fill: "url(#paint10_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.035 52.8885C185.035 57.0477 182.572 61.5564 179.52 61.6063C176.45 61.6566 173.949 57.1838 173.949 52.9825C173.949 48.7811 176.45 46.4767 179.52 46.4688C182.572 46.4608 185.035 48.7294 185.035 52.8885Z",
    fill: "url(#paint11_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.784 54.0435C174.091 53.9914 174.398 53.9393 174.704 53.8872C174.563 53.5445 173.982 52.0267 174.704 50.689C175.397 49.4054 177.029 48.7733 178.275 48.8515C179.69 48.9402 180.539 49.5995 181.249 49.0819C181.648 48.791 181.777 48.2657 181.823 47.8569C181.854 48.1182 181.926 48.5046 182.109 48.931C182.637 50.1559 183.53 50.4063 184.017 51.2149C184.344 51.7592 184.557 52.6726 184.017 54.2885C184.286 54.2696 184.556 54.2507 184.825 54.2319C185.11 53.3248 185.451 52.039 185.663 50.4673C185.978 48.1338 186.194 46.5276 185.3 45.748C185.122 45.5927 184.334 44.9768 182.448 45.5612C182.006 45.0938 181.074 44.2383 179.641 43.8075C179.145 43.6585 176.685 42.9191 174.503 44.5223C173.019 45.6128 171.856 47.6459 172.23 49.324C172.427 50.2113 172.968 50.6077 173.444 52.3226C173.645 53.0466 173.738 53.6564 173.784 54.0435Z",
    fill: "url(#paint12_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.269 54.4307C184.269 54.4307 184.623 52.6054 185.698 52.777C186.771 52.9483 185.233 55.9476 184.269 56.3176V54.4307Z",
    fill: "url(#paint13_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.64 54.5251C174.64 54.5251 174.279 52.6896 173.181 52.8812C172.082 53.0731 173.656 56.0775 174.64 56.4287V54.5251Z",
    fill: "url(#paint14_linear_297_59)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M196.274 114.179C187.378 114.463 180 107.24 180 98.0738C180 88.9073 187.378 81.5011 196.274 81.5629C204.986 81.6235 211.942 88.8513 211.942 97.6761C211.942 106.501 204.986 113.902 196.274 114.179Z",
    fill: "url(#paint15_linear_297_59)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.395 114.179C188.499 114.463 181.121 107.24 181.121 98.0738C181.121 88.9073 188.499 81.5011 197.395 81.5629C206.108 81.6235 213.063 88.8513 213.063 97.6761C213.063 106.501 206.108 113.902 197.395 114.179Z",
    fill: "url(#paint16_linear_297_59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.001 97.6895C212.001 105.929 205.525 112.807 197.396 113.055C189.105 113.308 182.264 106.596 182.264 98.0597C182.264 89.5231 189.105 82.6412 197.396 82.6877C205.525 82.7333 212.001 89.4495 212.001 97.6895Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 83,
    width: 28,
    height: 29
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.937 97.7029C210.937 105.342 204.929 111.711 197.396 111.93C189.725 112.154 183.403 105.939 183.403 98.0457C183.403 90.1519 189.725 83.7798 197.396 83.8126C204.929 83.8448 210.937 90.0634 210.937 97.7029Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.264 108.529C182.264 108.529 195.557 100.31 212.001 107.795C212.001 107.795 209.906 114.605 197.396 115.353C184.501 116.125 182.264 108.529 182.264 108.529Z",
    fill: "url(#paint17_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.039 97.901L194.541 101.685C194.396 104.091 192.061 105.043 192.061 105.043C194.803 108.295 200.043 108.048 201.876 104.868C200.61 104.414 199.19 102.456 199.135 101.069L199.007 97.8516L195.039 97.901Z",
    fill: "url(#paint18_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.085 94.4961C201.085 97.681 199.2 101.134 196.862 101.172C194.511 101.21 192.596 97.7853 192.596 94.5681C192.596 91.3508 194.511 89.5862 196.862 89.5801C199.2 89.574 201.085 91.3112 201.085 94.4961Z",
    fill: "url(#paint19_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47 95.3804C192.705 95.3404 192.94 95.3005 193.175 95.2607C193.067 94.9983 192.621 93.8359 193.175 92.8116C193.705 91.8287 194.955 91.3446 195.909 91.4045C196.992 91.4724 197.643 91.9773 198.186 91.5809C198.492 91.3582 198.591 90.9559 198.626 90.6429C198.65 90.8429 198.704 91.1388 198.845 91.4654C199.249 92.4034 199.933 92.5951 200.306 93.2143C200.556 93.6311 200.719 94.3306 200.306 95.568C200.512 95.5535 200.719 95.539 200.925 95.5246C201.143 94.83 201.404 93.8454 201.566 92.6418C201.807 90.8549 201.973 89.6249 201.289 89.028C201.152 88.909 200.549 88.4374 199.104 88.8849C198.766 88.527 198.052 87.8719 196.955 87.542C196.575 87.4279 194.691 86.8617 193.02 88.0894C191.884 88.9244 190.993 90.4813 191.28 91.7663C191.431 92.4458 191.845 92.7493 192.21 94.0625C192.363 94.617 192.434 95.0839 192.47 95.3804Z",
    fill: "url(#paint20_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.498 95.6754C200.498 95.6754 200.769 94.2777 201.592 94.4091C202.414 94.5403 201.237 96.8371 200.498 97.1204V95.6754Z",
    fill: "url(#paint21_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.125 95.7501C193.125 95.7501 192.849 94.3445 192.008 94.4912C191.166 94.6382 192.372 96.9388 193.125 97.2077V95.7501Z",
    fill: "url(#paint22_linear_297_59)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3994 181.117C62.5029 181.4 55.125 174.178 55.125 165.011C55.125 155.845 62.5029 148.439 71.3994 148.5C80.1114 148.561 87.067 155.789 87.067 164.614C87.0671 173.438 80.1115 180.839 71.3994 181.117Z",
    fill: "url(#paint23_linear_297_59)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5205 181.117C63.624 181.4 56.2461 174.178 56.2461 165.011C56.2461 155.845 63.624 148.439 72.5205 148.5C81.2325 148.561 88.1881 155.789 88.1881 164.614C88.1881 173.438 81.2325 180.839 72.5205 181.117Z",
    fill: "url(#paint24_linear_297_59)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1264 164.627C87.1264 172.867 80.6504 179.744 72.5205 179.992C64.2302 180.245 57.3887 173.534 57.3887 164.997C57.3887 156.461 64.2302 149.579 72.5205 149.625C80.6504 149.671 87.1264 156.387 87.1264 164.627Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 150,
    width: 29,
    height: 29
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.062 164.64C86.062 172.28 80.0536 178.648 72.5206 178.868C64.8501 179.092 58.5283 172.877 58.5283 164.983C58.5283 157.089 64.8501 150.717 72.5206 150.75C80.0536 150.782 86.062 157.001 86.062 164.64Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3887 175.466C57.3887 175.466 70.6824 167.248 87.1264 174.732C87.1264 174.732 85.0312 181.542 72.5205 182.291C59.6259 183.062 57.3887 175.466 57.3887 175.466Z",
    fill: "url(#paint25_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1642 164.838L69.6659 168.623C69.5212 171.029 67.186 171.98 67.186 171.98C69.9276 175.232 75.1685 174.985 77.0012 171.805C75.7347 171.351 74.3149 169.394 74.2596 168.007L74.1315 164.789L70.1642 164.838Z",
    fill: "url(#paint26_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2103 161.434C76.2103 164.619 74.3248 168.071 71.9871 168.109C69.6364 168.148 67.7212 164.723 67.7212 161.506C67.7212 158.288 69.6364 156.524 71.9871 156.518C74.3248 156.511 76.2103 158.249 76.2103 161.434Z",
    fill: "url(#paint27_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5946 162.318C67.8298 162.278 68.0647 162.238 68.2996 162.198C68.1917 161.936 67.7464 160.773 68.2996 159.749C68.8304 158.766 70.08 158.282 71.034 158.342C72.1175 158.41 72.7677 158.915 73.3113 158.518C73.6169 158.296 73.7157 157.893 73.7507 157.58C73.7748 157.78 73.8295 158.076 73.9702 158.403C74.3744 159.341 75.0583 159.533 75.4307 160.152C75.6813 160.569 75.8443 161.268 75.4307 162.505C75.6371 162.491 75.8435 162.477 76.0498 162.462C76.2676 161.767 76.5288 160.783 76.6912 159.579C76.9323 157.792 77.0983 156.562 76.4136 155.965C76.2771 155.847 75.6737 155.375 74.2291 155.822C73.8907 155.464 73.1774 154.809 72.0796 154.479C71.6998 154.365 69.816 153.799 68.1454 155.027C67.0091 155.862 66.1183 157.419 66.4046 158.704C66.556 159.383 66.9702 159.687 67.3346 161C67.4884 161.554 67.5592 162.021 67.5946 162.318Z",
    fill: "url(#paint28_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.623 162.613C75.623 162.613 75.8942 161.215 76.7174 161.347C77.539 161.478 76.3615 163.775 75.623 164.058V162.613Z",
    fill: "url(#paint29_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2499 162.688C68.2499 162.688 67.9738 161.282 67.1332 161.429C66.291 161.576 67.497 163.876 68.2499 164.145V162.688Z",
    fill: "url(#paint30_linear_297_59)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.399 188.992C107.503 189.275 100.125 182.053 100.125 172.886C100.125 163.72 107.503 156.314 116.399 156.375C125.111 156.436 132.067 163.664 132.067 172.489C132.067 181.313 125.111 188.714 116.399 188.992Z",
    fill: "url(#paint31_linear_297_59)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.52 188.992C108.624 189.275 101.246 182.053 101.246 172.886C101.246 163.72 108.624 156.314 117.52 156.375C126.233 156.436 133.188 163.664 133.188 172.489C133.188 181.313 126.233 188.714 117.52 188.992Z",
    fill: "url(#paint32_linear_297_59)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.126 172.502C132.126 180.742 125.65 187.619 117.521 187.867C109.23 188.12 102.389 181.409 102.389 172.872C102.389 164.336 109.23 157.454 117.521 157.5C125.65 157.546 132.126 164.262 132.126 172.502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 158,
    width: 29,
    height: 29
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.062 172.515C131.062 180.155 125.054 186.523 117.521 186.743C109.85 186.967 103.528 180.752 103.528 172.858C103.528 164.964 109.85 158.592 117.521 158.625C125.054 158.657 131.062 164.876 131.062 172.515Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.389 183.341C102.389 183.341 115.682 175.123 132.126 182.607C132.126 182.607 130.031 189.417 117.521 190.166C104.626 190.937 102.389 183.341 102.389 183.341Z",
    fill: "url(#paint33_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.164 172.713L114.666 176.498C114.521 178.904 112.186 179.855 112.186 179.855C114.928 183.107 120.168 182.86 122.001 179.68C120.735 179.226 119.315 177.269 119.26 175.882L119.132 172.664L115.164 172.713Z",
    fill: "url(#paint34_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21 169.309C121.21 172.494 119.325 175.946 116.987 175.984C114.636 176.023 112.721 172.598 112.721 169.381C112.721 166.163 114.636 164.399 116.987 164.393C119.325 164.386 121.21 166.124 121.21 169.309Z",
    fill: "url(#paint35_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.595 170.193C112.83 170.153 113.065 170.113 113.3 170.073C113.192 169.811 112.746 168.648 113.3 167.624C113.83 166.641 115.08 166.157 116.034 166.217C117.117 166.285 117.768 166.79 118.311 166.393C118.617 166.171 118.716 165.768 118.751 165.455C118.775 165.655 118.829 165.951 118.97 166.278C119.374 167.216 120.058 167.408 120.431 168.027C120.681 168.444 120.844 169.143 120.431 170.38C120.637 170.366 120.844 170.352 121.05 170.337C121.268 169.642 121.529 168.658 121.691 167.454C121.932 165.667 122.098 164.437 121.414 163.84C121.277 163.722 120.674 163.25 119.229 163.697C118.891 163.339 118.177 162.684 117.08 162.354C116.7 162.24 114.816 161.674 113.145 162.902C112.009 163.737 111.118 165.294 111.405 166.579C111.556 167.258 111.97 167.562 112.335 168.875C112.488 169.429 112.559 169.896 112.595 170.193Z",
    fill: "url(#paint36_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.623 170.488C120.623 170.488 120.894 169.09 121.717 169.222C122.539 169.353 121.362 171.65 120.623 171.933V170.488Z",
    fill: "url(#paint37_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.25 170.563C113.25 170.563 112.974 169.157 112.133 169.304C111.291 169.451 112.497 171.751 113.25 172.02V170.563Z",
    fill: "url(#paint38_linear_297_59)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M154.649 179.992C145.753 180.275 138.375 173.053 138.375 163.886C138.375 154.72 145.753 147.314 154.649 147.375C163.361 147.436 170.317 154.664 170.317 163.489C170.317 172.313 163.361 179.714 154.649 179.992Z",
    fill: "url(#paint39_linear_297_59)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155.77 179.992C146.874 180.275 139.496 173.053 139.496 163.886C139.496 154.72 146.874 147.314 155.77 147.375C164.483 147.436 171.438 154.664 171.438 163.489C171.438 172.313 164.483 179.714 155.77 179.992Z",
    fill: "url(#paint40_linear_297_59)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.376 163.502C170.376 171.742 163.9 178.619 155.771 178.867C147.48 179.12 140.639 172.409 140.639 163.872C140.639 155.336 147.48 148.454 155.771 148.5C163.9 148.546 170.376 155.262 170.376 163.502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 149,
    width: 29,
    height: 29
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.312 163.515C169.312 171.155 163.304 177.523 155.771 177.743C148.1 177.967 141.778 171.752 141.778 163.858C141.778 155.964 148.1 149.592 155.771 149.625C163.304 149.657 169.312 155.876 169.312 163.515Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.639 174.341C140.639 174.341 153.932 166.123 170.376 173.607C170.376 173.607 168.281 180.417 155.771 181.166C142.876 181.937 140.639 174.341 140.639 174.341Z",
    fill: "url(#paint41_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.414 163.713L152.916 167.498C152.771 169.904 150.436 170.855 150.436 170.855C153.178 174.107 158.418 173.86 160.251 170.68C158.985 170.226 157.565 168.269 157.51 166.882L157.382 163.664L153.414 163.713Z",
    fill: "url(#paint42_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.46 160.309C159.46 163.494 157.575 166.946 155.237 166.984C152.886 167.023 150.971 163.598 150.971 160.381C150.971 157.163 152.886 155.399 155.237 155.393C157.575 155.386 159.46 157.124 159.46 160.309Z",
    fill: "url(#paint43_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.845 161.193C151.08 161.153 151.315 161.113 151.55 161.073C151.442 160.811 150.996 159.648 151.55 158.624C152.08 157.641 153.33 157.157 154.284 157.217C155.367 157.285 156.018 157.79 156.561 157.393C156.867 157.171 156.966 156.768 157.001 156.455C157.025 156.655 157.079 156.951 157.22 157.278C157.624 158.216 158.308 158.408 158.681 159.027C158.931 159.444 159.094 160.143 158.681 161.38C158.887 161.366 159.094 161.352 159.3 161.337C159.518 160.642 159.779 159.658 159.941 158.454C160.182 156.667 160.348 155.437 159.664 154.84C159.527 154.722 158.924 154.25 157.479 154.697C157.141 154.339 156.427 153.684 155.33 153.354C154.95 153.24 153.066 152.674 151.395 153.902C150.259 154.737 149.368 156.294 149.655 157.579C149.806 158.258 150.22 158.562 150.585 159.875C150.738 160.429 150.809 160.896 150.845 161.193Z",
    fill: "url(#paint44_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.873 161.488C158.873 161.488 159.144 160.09 159.967 160.222C160.789 160.353 159.612 162.65 158.873 162.933V161.488Z",
    fill: "url(#paint45_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5 161.563C151.5 161.563 151.224 160.157 150.383 160.304C149.541 160.451 150.747 162.751 151.5 163.02V161.563Z",
    fill: "url(#paint46_linear_297_59)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M178.274 148.492C169.378 148.775 162 141.553 162 132.386C162 123.22 169.378 115.814 178.274 115.875C186.986 115.936 193.942 123.164 193.942 131.989C193.942 140.813 186.986 148.214 178.274 148.492Z",
    fill: "url(#paint47_linear_297_59)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.395 148.492C170.499 148.775 163.121 141.553 163.121 132.386C163.121 123.22 170.499 115.814 179.395 115.875C188.108 115.936 195.063 123.164 195.063 131.989C195.063 140.813 188.108 148.214 179.395 148.492Z",
    fill: "url(#paint48_linear_297_59)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M194.001 132.002C194.001 140.242 187.525 147.119 179.396 147.367C171.105 147.62 164.264 140.909 164.264 132.372C164.264 123.836 171.105 116.954 179.396 117C187.525 117.046 194.001 123.762 194.001 132.002Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 118,
    width: 28,
    height: 29
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.937 132.015C192.937 139.655 186.929 146.023 179.396 146.243C171.725 146.467 165.403 140.252 165.403 132.358C165.403 124.464 171.725 118.092 179.396 118.125C186.929 118.157 192.937 124.376 192.937 132.015Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.264 142.841C164.264 142.841 177.557 134.623 194.001 142.107C194.001 142.107 191.906 148.917 179.396 149.666C166.501 150.437 164.264 142.841 164.264 142.841Z",
    fill: "url(#paint49_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.039 132.213L176.541 135.998C176.396 138.404 174.061 139.355 174.061 139.355C176.803 142.607 182.043 142.36 183.876 139.18C182.61 138.726 181.19 136.769 181.135 135.382L181.007 132.164L177.039 132.213Z",
    fill: "url(#paint50_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.085 128.809C183.085 131.994 181.2 135.446 178.862 135.484C176.511 135.523 174.596 132.098 174.596 128.881C174.596 125.663 176.511 123.899 178.862 123.893C181.2 123.886 183.085 125.624 183.085 128.809Z",
    fill: "url(#paint51_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47 129.693C174.705 129.653 174.94 129.613 175.175 129.573C175.067 129.311 174.621 128.148 175.175 127.124C175.705 126.141 176.955 125.657 177.909 125.717C178.992 125.785 179.643 126.29 180.186 125.893C180.492 125.671 180.591 125.268 180.626 124.955C180.65 125.155 180.704 125.451 180.845 125.778C181.249 126.716 181.933 126.908 182.306 127.527C182.556 127.944 182.719 128.643 182.306 129.88C182.512 129.866 182.719 129.852 182.925 129.837C183.143 129.142 183.404 128.158 183.566 126.954C183.807 125.167 183.973 123.937 183.289 123.34C183.152 123.222 182.549 122.75 181.104 123.197C180.766 122.839 180.052 122.184 178.955 121.854C178.575 121.74 176.691 121.174 175.02 122.402C173.884 123.237 172.993 124.794 173.28 126.079C173.431 126.758 173.845 127.062 174.21 128.375C174.363 128.929 174.434 129.396 174.47 129.693Z",
    fill: "url(#paint52_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.498 129.988C182.498 129.988 182.769 128.59 183.592 128.722C184.414 128.853 183.237 131.15 182.498 131.433V129.988Z",
    fill: "url(#paint53_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.125 130.063C175.125 130.063 174.849 128.657 174.008 128.804C173.166 128.951 174.372 131.251 175.125 131.52V130.063Z",
    fill: "url(#paint54_linear_297_59)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8994 55.1169C22.0029 55.4003 14.625 48.1778 14.625 39.0113C14.625 29.8448 22.0029 22.4386 30.8994 22.5004C39.6114 22.561 46.567 29.7888 46.567 38.6136C46.5671 47.4384 39.6115 54.8394 30.8994 55.1169Z",
    fill: "url(#paint55_linear_297_59)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0205 55.1169C23.124 55.4003 15.7461 48.1778 15.7461 39.0113C15.7461 29.8448 23.124 22.4386 32.0205 22.5004C40.7325 22.561 47.6881 29.7888 47.6881 38.6136C47.6881 47.4384 40.7325 54.8394 32.0205 55.1169Z",
    fill: "url(#paint56_linear_297_59)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6264 38.627C46.6264 46.8669 40.1504 53.7443 32.0205 53.9924C23.7302 54.2454 16.8887 47.5338 16.8887 38.9972C16.8887 30.4606 23.7302 23.5787 32.0205 23.6252C40.1504 23.6708 46.6264 30.387 46.6264 38.627Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 24,
    width: 28,
    height: 29
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.562 38.6404C45.562 46.2798 39.5536 52.648 32.0206 52.8678C24.3501 53.0917 18.0283 46.8769 18.0283 38.9832C18.0283 31.0894 24.3501 24.7173 32.0206 24.7501C39.5536 24.7823 45.562 31.0009 45.562 38.6404Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8887 49.4662C16.8887 49.4662 30.1824 41.2478 46.6264 48.7321C46.6264 48.7321 44.5312 55.5424 32.0205 56.2908C19.1259 57.0621 16.8887 49.4662 16.8887 49.4662Z",
    fill: "url(#paint57_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6642 38.8385L29.1659 42.6229C29.0212 45.0286 26.686 45.9803 26.686 45.9803C29.4276 49.2324 34.6685 48.9852 36.5012 45.805C35.2347 45.3512 33.8149 43.3938 33.7596 42.007L33.6315 38.7891L29.6642 38.8385Z",
    fill: "url(#paint58_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7103 35.4336C35.7103 38.6185 33.8248 42.0711 31.4871 42.1094C29.1364 42.1479 27.2212 38.7228 27.2212 35.5056C27.2212 32.2883 29.1364 30.5237 31.4871 30.5176C33.8248 30.5115 35.7103 32.2487 35.7103 35.4336Z",
    fill: "url(#paint59_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0946 36.3179C27.3298 36.2779 27.5647 36.238 27.7996 36.1982C27.6917 35.9358 27.2464 34.7734 27.7996 33.7491C28.3304 32.7662 29.58 32.2821 30.534 32.342C31.6175 32.4099 32.2677 32.9148 32.8113 32.5184C33.1169 32.2957 33.2157 31.8934 33.2507 31.5804C33.2748 31.7804 33.3295 32.0763 33.4702 32.4029C33.8744 33.3409 34.5583 33.5326 34.9307 34.1518C35.1813 34.5686 35.3443 35.2681 34.9307 36.5055C35.1371 36.491 35.3435 36.4765 35.5498 36.4621C35.7676 35.7675 36.0288 34.7829 36.1912 33.5793C36.4323 31.7924 36.5983 30.5624 35.9136 29.9655C35.7771 29.8465 35.1737 29.3749 33.7291 29.8224C33.3907 29.4645 32.6774 28.8094 31.5796 28.4795C31.1998 28.3654 29.316 27.7992 27.6454 29.0269C26.5091 29.8619 25.6183 31.4188 25.9046 32.7038C26.056 33.3833 26.4702 33.6868 26.8346 35C26.9884 35.5545 27.0592 36.0214 27.0946 36.3179Z",
    fill: "url(#paint60_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.123 36.6129C35.123 36.6129 35.3942 35.2152 36.2174 35.3466C37.039 35.4778 35.8615 37.7746 35.123 38.0579V36.6129Z",
    fill: "url(#paint61_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7499 36.6876C27.7499 36.6876 27.4738 35.282 26.6332 35.4287C25.791 35.5757 26.997 37.8763 27.7499 38.1452V36.6876Z",
    fill: "url(#paint62_linear_297_59)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3994 47.8044C62.5029 48.0878 55.125 40.8653 55.125 31.6988C55.125 22.5323 62.5029 15.1261 71.3994 15.1879C80.1114 15.2485 87.067 22.4763 87.067 31.3011C87.0671 40.1259 80.1115 47.5269 71.3994 47.8044Z",
    fill: "url(#paint63_linear_297_59)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5205 47.8044C63.624 48.0878 56.2461 40.8653 56.2461 31.6988C56.2461 22.5323 63.624 15.1261 72.5205 15.1879C81.2325 15.2485 88.1881 22.4763 88.1881 31.3011C88.1881 40.1259 81.2325 47.5269 72.5205 47.8044Z",
    fill: "url(#paint64_linear_297_59)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1264 31.3145C87.1264 39.5544 80.6504 46.4318 72.5205 46.6799C64.2302 46.9329 57.3887 40.2213 57.3887 31.6847C57.3887 23.1481 64.2302 16.2662 72.5205 16.3127C80.6504 16.3583 87.1264 23.0745 87.1264 31.3145Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 17,
    width: 29,
    height: 29
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.062 31.3279C86.062 38.9673 80.0536 45.3355 72.5206 45.5553C64.8501 45.7792 58.5283 39.5644 58.5283 31.6707C58.5283 23.7769 64.8501 17.4048 72.5206 17.4376C80.0536 17.4698 86.062 23.6884 86.062 31.3279Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3887 42.1537C57.3887 42.1537 70.6824 33.9353 87.1264 41.4196C87.1264 41.4196 85.0312 48.2299 72.5205 48.9783C59.6259 49.7496 57.3887 42.1537 57.3887 42.1537Z",
    fill: "url(#paint65_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1642 31.526L69.6659 35.3104C69.5212 37.7161 67.186 38.6678 67.186 38.6678C69.9276 41.9199 75.1685 41.6727 77.0012 38.4925C75.7347 38.0387 74.3149 36.0813 74.2596 34.6945L74.1315 31.4766L70.1642 31.526Z",
    fill: "url(#paint66_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2103 28.1211C76.2103 31.306 74.3248 34.7586 71.9871 34.7969C69.6364 34.8354 67.7212 31.4103 67.7212 28.1931C67.7212 24.9758 69.6364 23.2112 71.9871 23.2051C74.3248 23.199 76.2103 24.9362 76.2103 28.1211Z",
    fill: "url(#paint67_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5946 29.0054C67.8298 28.9654 68.0647 28.9255 68.2996 28.8857C68.1917 28.6233 67.7464 27.4609 68.2996 26.4366C68.8304 25.4537 70.08 24.9696 71.034 25.0295C72.1175 25.0974 72.7677 25.6023 73.3113 25.2059C73.6169 24.9832 73.7157 24.5809 73.7507 24.2679C73.7748 24.4679 73.8295 24.7638 73.9702 25.0904C74.3744 26.0284 75.0583 26.2201 75.4307 26.8393C75.6813 27.2561 75.8443 27.9556 75.4307 29.193C75.6371 29.1785 75.8435 29.164 76.0498 29.1496C76.2676 28.455 76.5288 27.4704 76.6912 26.2668C76.9323 24.4799 77.0983 23.2499 76.4136 22.653C76.2771 22.534 75.6737 22.0624 74.2291 22.5099C73.8907 22.152 73.1774 21.4969 72.0796 21.167C71.6998 21.0529 69.816 20.4867 68.1454 21.7144C67.0091 22.5494 66.1183 24.1063 66.4046 25.3913C66.556 26.0708 66.9702 26.3743 67.3346 27.6875C67.4884 28.242 67.5592 28.7089 67.5946 29.0054Z",
    fill: "url(#paint68_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.623 29.3004C75.623 29.3004 75.8942 27.9027 76.7174 28.0341C77.539 28.1653 76.3615 30.4621 75.623 30.7454V29.3004Z",
    fill: "url(#paint69_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2499 29.3751C68.2499 29.3751 67.9738 27.9695 67.1332 28.1162C66.291 28.2632 67.497 30.5638 68.2499 30.8327V29.3751Z",
    fill: "url(#paint70_linear_297_59)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M124.926 53.195C110.141 53.077 97.875 40.8187 97.875 25.8715C97.875 10.9243 110.141 -0.662279 124.926 0.0294282C139.398 0.706547 150.949 12.9454 150.949 27.3248C150.949 41.7041 139.398 53.3104 124.926 53.195Z",
    fill: "url(#paint71_linear_297_59)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M126.719 53.195C111.934 53.077 99.668 40.8187 99.668 25.8715C99.668 10.9243 111.934 -0.662279 126.719 0.0294282C141.191 0.706547 152.742 12.9454 152.742 27.3248C152.742 41.7041 141.191 53.3104 126.719 53.195Z",
    fill: "url(#paint72_linear_297_59)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 27.2757C150.979 40.7024 140.224 51.4867 126.719 51.3609C112.942 51.2326 101.568 39.8424 101.568 25.9227C101.568 12.003 112.942 1.2358 126.719 1.86192C140.224 2.47573 150.979 13.849 150.979 27.2757Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_297_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 3,
    width: 47,
    height: 47
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.211 27.2286C149.211 39.677 139.233 49.6622 126.719 49.5289C113.971 49.3931 103.462 38.847 103.462 25.9759C103.462 13.1048 113.971 3.13424 126.719 3.69649C139.233 4.24846 149.211 14.7801 149.211 27.2286Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_297_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.369 42.9626C107.039 39.1033 112.034 37.7869 112.67 28.8051C112.714 28.1952 113.56 15.927 115.446 13.5698C115.697 13.2565 115.977 13.0084 115.977 13.0084C116.92 12.2775 118.378 12.363 123.581 10.1925C128.04 8.33233 127.782 8.38599 128.358 8.28006C131.71 7.66397 136.666 10.7324 138.297 14.8268C139.76 18.4989 138.005 21.6339 140.627 28.0879L140.627 28.0882C143.878 37.3748 145.503 42.0181 144.032 44.9338C139.561 53.7952 111.356 51.6255 108.369 42.9626Z",
    fill: "url(#paint73_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.568 42.9333C101.568 42.9333 123.664 30.4072 150.979 43.6838C150.979 43.6838 147.5 54.6445 126.719 55.0484C105.287 55.465 101.568 42.9333 101.568 42.9333Z",
    fill: "url(#paint74_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.803 26.5059L121.975 32.6421C121.693 34.7359 120.244 36.4673 118.229 37.115L111.494 39.2796C111.494 39.2796 124.384 45.6809 140.664 39.7436L133.242 37.0429C131.136 36.2177 129.7 34.2038 129.608 31.9398L129.395 26.6864L122.803 26.5059Z",
    fill: "url(#paint75_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.849 21.3539C132.849 26.545 129.717 32.0485 125.833 31.9573C121.926 31.8657 118.744 26.1563 118.744 20.9116C118.744 15.6668 121.926 12.9167 125.833 13.0621C129.716 13.2069 132.849 16.1629 132.849 21.3539Z",
    fill: "url(#paint76_linear_297_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.508 24.2864C119.181 24.2693 118.209 18.7948 120.818 17.3567C122.55 16.402 125.556 17.3985 127.246 19.2245C129.91 22.1025 128.42 26.0947 130.438 27.0081C131.719 27.5879 133.429 26.4772 134.248 25.653C136.807 23.0792 136.458 17.4743 133.433 14.2281C131.022 11.6403 127.75 11.4474 126.972 11.4255C122.517 11.2997 118.427 14.4812 117.489 18.3509C116.768 21.3249 118.01 24.2991 118.508 24.2864Z",
    fill: "url(#paint77_linear_297_59)"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2635 90.0621V102.29H34.7223V107.942H23.2635V120.17H17.6111V107.942H6.15234V102.29H17.6111V90.0621H23.2635ZM45.7581 124.169L52.7948 122.862V83.1023H43.3356L42.951 79.1417L55.8325 75.9117H60.1007V122.862L67.099 124.169L66.33 127.938H46.5271L45.7581 124.169ZM90.4779 128.783C84.6588 128.783 80.3394 127.053 77.5195 123.592C74.6997 120.106 73.2898 114.928 73.2898 108.058V104.02C73.2898 94.5098 74.9048 87.3064 78.1348 82.4102C81.3904 77.5139 85.979 75.0658 91.9006 75.0658C98.0017 75.0658 102.501 76.7577 105.397 80.1415C108.294 83.4996 109.742 88.7291 109.742 95.83V99.829C109.742 109.493 108.204 116.735 105.128 121.554C102.078 126.374 97.1942 128.783 90.4779 128.783ZM102.283 97.8679C102.283 91.7668 101.462 87.2679 99.8218 84.3712C98.2068 81.4745 95.4382 80.0261 91.5161 80.0261C87.6453 80.0261 84.8767 81.6539 83.2104 84.9095C81.5698 88.1395 80.7495 93.3562 80.7495 100.56V105.943C80.7495 112.018 81.6083 116.517 83.3258 119.44C85.0433 122.362 87.7478 123.823 91.4392 123.823C95.4382 123.823 98.2452 122.118 99.8602 118.709C101.475 115.3 102.283 110.147 102.283 103.251V97.8679Z",
    fill: "#662D91"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_59",
    x1: 120.938,
    y1: 98.1258,
    x2: 161.698,
    y2: 98.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_297_59",
    x1: 122.322,
    y1: 98.5868,
    x2: 163.082,
    y2: 98.5868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#602A88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_297_59",
    x1: 149.268,
    y1: 84.6233,
    x2: 143.634,
    y2: 102.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_297_59",
    x1: 123.781,
    y1: 113.811,
    x2: 161.728,
    y2: 113.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_297_59",
    x1: 142.561,
    y1: 100.116,
    x2: 142.634,
    y2: 114.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_297_59",
    x1: 144.57,
    y1: 79.7377,
    x2: 141.305,
    y2: 101.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_297_59",
    x1: 145.156,
    y1: 83.1991,
    x2: 139.336,
    y2: 101.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_297_59",
    x1: 157.5,
    y1: 57.3022,
    x2: 199.213,
    y2: 57.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_297_59",
    x1: 158.964,
    y1: 57.3022,
    x2: 200.676,
    y2: 57.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_297_59",
    x1: 160.456,
    y1: 73.172,
    x2: 199.29,
    y2: 73.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_297_59",
    x1: 179.62,
    y1: 58.9499,
    x2: 179.694,
    y2: 73.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_297_59",
    x1: 181.736,
    y1: 39.1312,
    x2: 178.109,
    y2: 61.5282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_297_59",
    x1: 179.83,
    y1: 43.7722,
    x2: 178.055,
    y2: 54.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_297_59",
    x1: 187.411,
    y1: 40.0637,
    x2: 183.796,
    y2: 62.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_297_59",
    x1: 176.414,
    y1: 38.2711,
    x2: 172.78,
    y2: 60.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_297_59",
    x1: 180,
    y1: 97.875,
    x2: 211.942,
    y2: 97.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_297_59",
    x1: 181.121,
    y1: 97.875,
    x2: 213.063,
    y2: 97.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_297_59",
    x1: 182.264,
    y1: 110.028,
    x2: 212.001,
    y2: 110.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_297_59",
    x1: 196.939,
    y1: 99.1384,
    x2: 196.995,
    y2: 110.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_297_59",
    x1: 198.559,
    y1: 83.9613,
    x2: 195.782,
    y2: 101.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_297_59",
    x1: 197.1,
    y1: 87.515,
    x2: 195.741,
    y2: 95.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_297_59",
    x1: 202.905,
    y1: 84.6737,
    x2: 200.136,
    y2: 101.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_297_59",
    x1: 194.484,
    y1: 83.3033,
    x2: 191.701,
    y2: 100.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_297_59",
    x1: 55.125,
    y1: 164.812,
    x2: 87.067,
    y2: 164.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_297_59",
    x1: 56.2461,
    y1: 164.812,
    x2: 88.1881,
    y2: 164.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_297_59",
    x1: 57.3887,
    y1: 176.966,
    x2: 87.1264,
    y2: 176.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_297_59",
    x1: 72.0637,
    y1: 166.076,
    x2: 72.1204,
    y2: 177.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_297_59",
    x1: 73.6841,
    y1: 150.899,
    x2: 70.9069,
    y2: 168.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_297_59",
    x1: 72.2249,
    y1: 154.452,
    x2: 70.8655,
    y2: 162.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_297_59",
    x1: 78.0298,
    y1: 151.611,
    x2: 75.2615,
    y2: 168.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_297_59",
    x1: 69.6087,
    y1: 150.241,
    x2: 66.826,
    y2: 167.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_297_59",
    x1: 100.125,
    y1: 172.687,
    x2: 132.067,
    y2: 172.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_297_59",
    x1: 101.246,
    y1: 172.687,
    x2: 133.188,
    y2: 172.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_297_59",
    x1: 102.389,
    y1: 184.841,
    x2: 132.126,
    y2: 184.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_297_59",
    x1: 117.064,
    y1: 173.951,
    x2: 117.12,
    y2: 184.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_297_59",
    x1: 118.684,
    y1: 158.774,
    x2: 115.907,
    y2: 175.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_297_59",
    x1: 117.225,
    y1: 162.327,
    x2: 115.866,
    y2: 170.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_297_59",
    x1: 123.03,
    y1: 159.486,
    x2: 120.261,
    y2: 176.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_297_59",
    x1: 114.609,
    y1: 158.116,
    x2: 111.826,
    y2: 175.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_297_59",
    x1: 138.375,
    y1: 163.687,
    x2: 170.317,
    y2: 163.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_297_59",
    x1: 139.496,
    y1: 163.687,
    x2: 171.438,
    y2: 163.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_297_59",
    x1: 140.639,
    y1: 175.841,
    x2: 170.376,
    y2: 175.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_297_59",
    x1: 155.314,
    y1: 164.951,
    x2: 155.37,
    y2: 175.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_297_59",
    x1: 156.934,
    y1: 149.774,
    x2: 154.157,
    y2: 166.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_297_59",
    x1: 155.475,
    y1: 153.327,
    x2: 154.116,
    y2: 161.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_297_59",
    x1: 161.28,
    y1: 150.486,
    x2: 158.511,
    y2: 167.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_297_59",
    x1: 152.859,
    y1: 149.116,
    x2: 150.076,
    y2: 166.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_297_59",
    x1: 162,
    y1: 132.187,
    x2: 193.942,
    y2: 132.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_297_59",
    x1: 163.121,
    y1: 132.187,
    x2: 195.063,
    y2: 132.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_297_59",
    x1: 164.264,
    y1: 144.341,
    x2: 194.001,
    y2: 144.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_297_59",
    x1: 178.939,
    y1: 133.451,
    x2: 178.995,
    y2: 144.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_297_59",
    x1: 180.559,
    y1: 118.274,
    x2: 177.782,
    y2: 135.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_297_59",
    x1: 179.1,
    y1: 121.827,
    x2: 177.741,
    y2: 130.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_297_59",
    x1: 184.905,
    y1: 118.986,
    x2: 182.136,
    y2: 136.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_297_59",
    x1: 176.484,
    y1: 117.616,
    x2: 173.701,
    y2: 134.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_297_59",
    x1: 14.625,
    y1: 38.8125,
    x2: 46.567,
    y2: 38.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_297_59",
    x1: 15.7461,
    y1: 38.8125,
    x2: 47.6881,
    y2: 38.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_297_59",
    x1: 16.8887,
    y1: 50.9659,
    x2: 46.6264,
    y2: 50.9659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_297_59",
    x1: 31.5637,
    y1: 40.0759,
    x2: 31.6204,
    y2: 51.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_297_59",
    x1: 33.1841,
    y1: 24.8988,
    x2: 30.4069,
    y2: 42.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_297_59",
    x1: 31.7249,
    y1: 28.4525,
    x2: 30.3655,
    y2: 36.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_297_59",
    x1: 37.5298,
    y1: 25.6112,
    x2: 34.7615,
    y2: 42.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_297_59",
    x1: 29.1087,
    y1: 24.2408,
    x2: 26.326,
    y2: 41.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_297_59",
    x1: 55.125,
    y1: 31.5,
    x2: 87.067,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_297_59",
    x1: 56.2461,
    y1: 31.5,
    x2: 88.1881,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_297_59",
    x1: 57.3887,
    y1: 43.6534,
    x2: 87.1264,
    y2: 43.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_297_59",
    x1: 72.0637,
    y1: 32.7634,
    x2: 72.1204,
    y2: 43.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_297_59",
    x1: 73.6841,
    y1: 17.5863,
    x2: 70.9069,
    y2: 34.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_297_59",
    x1: 72.2249,
    y1: 21.14,
    x2: 70.8655,
    y2: 29.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_297_59",
    x1: 78.0298,
    y1: 18.2987,
    x2: 75.2615,
    y2: 35.3948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_297_59",
    x1: 69.6087,
    y1: 16.9283,
    x2: 66.826,
    y2: 34.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_297_59",
    x1: 97.875,
    y1: 26.5979,
    x2: 150.949,
    y2: 26.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_297_59",
    x1: 99.668,
    y1: 26.5979,
    x2: 152.742,
    y2: 26.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_297_59",
    x1: 159.301,
    y1: -26.7799,
    x2: 96.4226,
    y2: 92.2997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_297_59",
    x1: 126.298,
    y1: 42.8747,
    x2: 123.907,
    y2: 85.6013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_297_59",
    x1: 126.023,
    y1: 28.6072,
    x2: 126.117,
    y2: 46.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_297_59",
    x1: 128.605,
    y1: 2.25835,
    x2: 124.397,
    y2: 30.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_297_59",
    x1: 138.74,
    y1: -2.39259,
    x2: 114.919,
    y2: 42.7198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Users);
export default __webpack_public_path__ + "static/media/10_users.d6700a04df8ac338c01d540bc1dd0679.svg";
export { ForwardRef as ReactComponent };